import { ReactElement, useState } from 'react';
import moment from 'moment';
import 'moment-timezone';
import ExpandedGroup from './ExpandedGroup';
import DropdownCustom from '../controls/DropdownCustom';
import { ActionData, ActionsTypes, Group, Option } from '../constants/telosair-interfaces';
import { useData } from '../context/data.context';

const options: Option<ActionsTypes>[] = [
  { name: 'Edit group', id: 'edit' },
  { name: 'Delete group', id: 'delete' }
];

type GroupProps = {
  group: Group;
  handleAction: (data: ActionData<Group>) => void;
  setIsGroupModalOpen: (isOpen: boolean) => void;
};

/**
 * A Group Component will render list of devices it has.
 * @param props - Properties of Group component.
 * @returns - A react Element.
 */
export default function GroupRow(props: GroupProps): ReactElement {
  const { group, handleAction, setIsGroupModalOpen } = props;
  const { userConfigData } = useData();
  const [showMoreDevice, setShowMoreDevice] = useState(false);
  const timeZone = userConfigData?.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  /**
   * Function to handle action.
   * @param type - Type of the action edit or delete.
   */
  const onAction = (type: ActionsTypes): void => {
    handleAction({ type, data: group });
  };

  return (
    <>
      <tr className="bg-white dark:bg-container-500 text-gray-500 dark:text-gray-300 border-b border-b-gray-300 dark:border-b-gray-900">
        <td className="w-[20%] sm:w-[40%]">
          <div
            role="button"
            aria-label="Show more or less"
            tabIndex={0}
            className="cursor-pointer h-11 px-2 sm:px-6 py-4 text-left inline-flex justify-center items-center gap-x-1.5 text-lg text-gray-300"
            onClick={() => setShowMoreDevice(!showMoreDevice)}
            onKeyDown={() => setShowMoreDevice(!showMoreDevice)}
          >
            <span style={{ color: '#F67B04' }} className="material-icons-outlined text-sm mr-1">
              api
            </span>
            {group.groupName}
            <span className="material-icons-outlined text-gray-700 dark:text-gray-400">
              {showMoreDevice ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
            </span>
          </div>
        </td>
        <td aria-label="space" className="w-[12%] py-3 text-center hidden lg:table-cell" />
        <td aria-label="space" className="w-[12%] py-3 text-center hidden lg:table-cell" />
        <td className="w-[15%] sm:w-[20%] lg:w-[12%] py-3 text-center">
          {group.sensorDetailsList.length}
        </td>
        <td className="w-[20%] py-3 text-center">
          {moment(group.lastModifiedDate).tz(timeZone).format('do MMM HH:mm a')}
          {/* <div className="text-gray-500 text-xs">(2hrs ago)</div> */}
        </td>
        <td className="w-[45%] sm:w-[20%] lg:w-[12%] py-3 px-6 text-center">
          <DropdownCustom<ActionsTypes>
            onClick={onAction}
            controlPlaceholder="Action"
            buttons={options}
          />
        </td>
      </tr>

      {showMoreDevice && (
        <ExpandedGroup
          setIsGroupModalOpen={setIsGroupModalOpen}
          devices={group.sensorDetailsList}
          group={group}
        />
      )}
    </>
  );
}
